//@flow

import styled from "styled-components"

const Divider = styled.span`
  display: block;
  background: rgba(255, 255, 255, 0.3);
  flex-basis: 1px;
  width: 1px;
  height: 300px;
  margin: auto 1rem 0 0;
`

export default Divider



// WEBPACK FOOTER //
// ./src/Kiosk/LocationsModal/Divider.js